"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendJSError = exports.sendLoadedService = exports.sendLoadingService = exports.createEvent = exports.finishStates = exports.processName = void 0;

/* global IC:true */
var processName = 'ADABYRON-API';
exports.processName = processName;
var NODE_ENV = process.env.NODE_ENV;
var finishStates = {
  FINISHED_OK: 'FINISHED_OK',
  FINISHED_KO: 'FINISHED_KO',
  FINISHED_KO_TIMEOUT: 'FINISHED_KO_TIMEOUT',
  FINISHED_KO_JS: 'FINISHED_KO_JS'
};
exports.finishStates = finishStates;

var createEvent = function createEvent(eventName) {
  var myEvent = null;

  try {
    if (IC && IC.createEvent) {
      myEvent = IC.createEvent(eventName);
    }
  } catch (err) {
    console.log('Error en adaByron-monitoring función createEvent con eventName: ' + eventName + ' --> ' + err);
  }

  return myEvent;
};

exports.createEvent = createEvent;

var sendLoadingService = function sendLoadingService(processName, myEvent, idRequest) {
  try {
    var idRequestToSend = idRequest;
    idRequestToSend = idRequestToSend ? idRequestToSend : '';

    if (IC && IC.trackEvent && myEvent) {
      IC.trackEvent('Started', myEvent.eventName, myEvent.id, '', idRequestToSend, processName);
    }
  } catch (err) {
    // eslint-disable-next-line max-len
    console.log('Error en adaByron-monitoring función sendLoadingService con eventName: ' + myEvent.eventName + ' --> ' + err);
  }
};

exports.sendLoadingService = sendLoadingService;

var sendLoadedService = function sendLoadedService(processName, myEvent, finishState, data, idRequest) {
  try {
    var idRequestToSend = idRequest;
    idRequestToSend = idRequestToSend ? idRequestToSend : '';
    var dataToSend = data === '' ? {} : data;
    dataToSend = typeof dataToSend === 'string' ? {
      datos: dataToSend
    } : dataToSend;
    dataToSend.idRequest = idRequestToSend;
    dataToSend = dataToSend ? JSON.stringify(dataToSend) : '';

    if (IC && IC.trackEvent) {
      if (finishState === finishStates.FINISHED_OK) {
        IC.trackEvent('Loaded', myEvent.eventName, myEvent.id, 'ok', dataToSend, processName);
      } else if (finishState === finishStates.FINISHED_KO) {
        IC.trackEvent('Loaded', myEvent.eventName, myEvent.id, 'error', dataToSend, processName);
      } else if (finishState === finishStates.FINISHED_KO_TIMEOUT) {
        IC.trackEvent('Loaded', myEvent.eventName, myEvent.id, 'timeout', dataToSend, processName);
      } else if (finishState === finishStates.FINISHED_KO_JS) {
        IC.trackEvent('Loaded', myEvent.eventName, myEvent.id, 'js-error', dataToSend, processName);
      }
    }

    if (NODE_ENV !== 'test') {
      if (sessionStorage.getItem('debug')) {
        console.log(finishState);
      }
    }
  } catch (err) {
    // eslint-disable-next-line max-len
    console.log('Error en adaByron-monitoring función sendLoadedService con eventName: ' + myEvent.eventName + ' --> ' + err);
  }
};

exports.sendLoadedService = sendLoadedService;

var sendJSError = function sendJSError(processName, method, data) {
  try {
    var dataToSend = JSON.stringify(data);

    if (IC && IC.trackErrorCtz) {
      IC.trackErrorCtz(processName, '', method, dataToSend);
    }
  } catch (err) {
    console.log('Error en adaByron-monitoring función sendJSError con processName: ' + processName + ' --> ' + err);
  }
};

exports.sendJSError = sendJSError;

//# sourceMappingURL=index.js.map